import React from 'react';
import { Nullable } from 'global';
import { Box } from '@mui/material';
import { useHorizontalScroll } from 'hooks/useHorizontalScroll';

import { LoadingProps } from './types';
import { StageBadge } from './StageBadge';
import { Stage, StageId } from '../../api';
import { determineStatus } from '../../lib';

interface Props {
  activeStage: StageId;
  viewedStage: Nullable<StageId>;
  stages: Record<StageId, Stage>;
  loading: LoadingProps['loading'];
  onViewStage: (stage: Stage) => void;
}

export const StagesList = ({ stages, loading, viewedStage, activeStage, onViewStage }: Props) => {
  const scrollRef = useHorizontalScroll();

  return (
    <Box className="stagesList" ref={scrollRef}>
      {Object.values(stages).map((stage, index, arr) => (
        <StageBadge
          stage={stage}
          showLeft={!!index}
          onClick={onViewStage}
          key={stage.businessProcessFlowStageId}
          isUpdating={loading.isBPFsUpdating}
          status={determineStatus(stage, activeStage, viewedStage)}
        />
      ))}
    </Box>
  );
};
